class UpsellTabs extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', event => {
      const tab = event.target.closest('[data-upsell-tab]');
      if (tab) this.activateTab(tab.dataset.upsellTab);
    });

    this.addEventListener('recommendations:loaded', event => {
      if (!event.target.querySelector('[data-upsell-item]')) {
        this.removeTab('upsells');
      }
    });
  }

  activateTab(name) {
    this.querySelectorAll('[data-upsell-tab]').forEach(tab => {
      tab.classList.toggle('active', tab.dataset.upsellTab === name);
    });
    this.querySelectorAll('[data-upsell-panel]').forEach(panel => {
      panel.classList.toggle('hidden', panel.dataset.upsellPanel !== name);
    });
  }

  removeTab(name) {
    this.querySelector(`[data-upsell-tab="${name}"]`)?.remove();
    this.querySelector(`[data-upsell-panel="${name}"]`)?.remove();

    const remaining = this.querySelector('[data-upsell-tab]');
    if (remaining) {
      this.activateTab(remaining.dataset.upsellTab);
    } else {
      this.remove();
    }
  }
}

if (!customElements.get('upsell-tabs')) {
  customElements.define('upsell-tabs', UpsellTabs);
}
